/* eslint-disable camelcase */
import { useState } from 'react';
// material
import { Modal, Box, Stack, Typography, Button } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { LoadingButton } from '@mui/lab';
import { PropTypes } from 'prop-types';
import { notification } from 'antd';
import instance from '../api/axiosRequest';

const openNotification = ({ message, description = '', type }) => {
  notification.open({
    type,
    message,
    description,
    duration: 4,
  });
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  px: 8,
  py: 4,
};

export default function ConfirmDeleteModal({ open, setOpen, setReload, path, data, item }) {
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      let fullPath = path;
      if (data.id) fullPath = `${path}/${data.id}`;
      await instance.delete(`${fullPath}`, { data });
      openNotification({
        message: `${item} deleted successfully.`,
        type: 'success',
      });
      setLoading(false);
      handleClose();
      setReload((state) => state + 1);
    } catch (error) {
      setLoading(false);
      let description = '';
      if (error.response.data.message) description = error.response.data.message;
      openNotification({
        message: `${item} not deleted.`,
        description,
        type: 'error',
      });
      console.log(error);
    }
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose} aria-labelledby="device-delete" aria-describedby="delete-device">
        <Box sx={style}>
          <Stack spacing={2} alignItems="center">
            <CancelOutlinedIcon sx={{ fontSize: '5em' }} />
            <Typography variant="h5">Delete {item}</Typography>
            <Typography>{item} will be permanently deleted.</Typography>
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: 'gray',
                  '&:hover': {
                    backgroundColor: 'gray',
                  },
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <LoadingButton variant="contained" color="error" onClick={handleDelete} loading={loading}>
                Delete
              </LoadingButton>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}

ConfirmDeleteModal.propTypes = {
  item: PropTypes.string,
  path: PropTypes.string,
  data: PropTypes.object,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setReload: PropTypes.func,
};

ConfirmDeleteModal.defaultProps = {
  setReload: () => {},
};
